import { render, staticRenderFns } from "./PrescriptionDialog.vue?vue&type=template&id=378ce21d"
import script from "./PrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./PrescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports